import React from "react";
import { Device } from "../../models";
import styles from "./styles.module.scss";
import ReactModal from "react-modal";
import { Api } from "../../Api";
import { Logger } from "../../Logger";

class CustomerAddDialog extends React.Component<ICustomerAddDialogProps, ICustomerAddDialogState> {
    constructor(props: ICustomerAddDialogProps) {
        super(props);

        this.state = {
            loading: false,
            name: ""
        };

        this.onSaveCustomer = this.onSaveCustomer.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
    }

    onSaveCustomer() {
        var that = this;
        this.setState({
            loading: true
        });
        Api.addCustomer(this.state.name).then(res => {
            Logger.LogSuccess("Klant toegevoegd");
            that.setState({
                loading: false,
                name: ""
            });
            that.props.modalClosed();
        });
    }

    onChangeName(e: React.FormEvent<HTMLInputElement>) {
        if (e.currentTarget.value && e.currentTarget.value.length <= 200)
            this.setState({ name: e.currentTarget.value });
    }

    render() {
        return (
            <ReactModal isOpen={true} className={styles.confirmModal} overlayClassName={styles.overlayConfirmModal} ariaHideApp={false}>
                <label>Naam: </label><input type="text" className="form-control" value={this.state.name} onChange={this.onChangeName} />

                <div className={styles.buttonContainer}>
                    <button className={[styles.button, 'btn', 'btn-success'].join(' ')} onClick={this.onSaveCustomer}>Opslaan</button>
                    <button className={[styles.button, 'btn', 'btn-danger'].join(' ')} onClick={this.props.modalClosed}>Sluiten</button>
                </div>
            </ReactModal>
        );
    }
}

export default CustomerAddDialog;

export interface ICustomerAddDialogProps {
    modalClosed: () => void;
}

export interface ICustomerAddDialogState {
    loading: boolean;
    name: string;
}